<script>
    export let model_root;
    export let user;

    let prename = user.uprename;
    let name = user.uname;
    let mail = user.umail;
    let uid = user.uid;

    let errorMsg = "";
    let successMsg = "";

    // Datums-Helper (gleiche Logik wie in der Tabelle)
    function isExpired(dateString) {
        if (!dateString) return false;
        return new Date(Date.parse(dateString.replace(/-/g, '/'))) < new Date();
    }

    // Check, ob der Link abgelaufen ist
    $: linkExpired = user.uhashvaliduntil && isExpired(user.uhashvaliduntil);

    function updateUser() {
        const data = new FormData();
        data.append("action", "update");
        data.append("uid", uid);
        data.append("prename", prename);
        data.append("name", name);
        data.append("mail", mail);
        sendRequest(data);
    }

    // Neue Funktion: Link erneut senden
    function resendLink() {
        let confirmText = "Soll ein neuer Zugangs-Link an den Nutzer gesendet werden?";
        if (!confirm(confirmText)) return;

        const data = new FormData();
        data.append("action", "resend_link"); // Nutzt die neue PHP-Logik
        data.append("uid", uid);

        sendRequest(data, false); // false = kein Reload nötig, Nachricht reicht meist
    }

    function deleteUser() {
        if(!confirm("Möchten Sie diesen Nutzer wirklich unwiderruflich löschen?")) return;
        const data = new FormData();
        data.append("action", "delete");
        data.append("uid", uid);
        sendRequest(data, true);
    }

    function sendRequest(formData, reload = false) {
        errorMsg = "";
        successMsg = "";

        fetch(model_root + 'admin/user_management/manage_user.php', {
            method: "POST",
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if(data.status === "success") {
                    successMsg = data.message;
                    if(reload) setTimeout(() => { location.reload() }, 1500);
                } else {
                    errorMsg = data.message;
                }
            })
            .catch(err => {
                errorMsg = "Ein Netzwerkfehler ist aufgetreten.";
            });
    }
</script>

<h5 class="mb-3">Nutzer verwalten: {user.uprename} {user.uname}</h5>

{#if linkExpired}
    <div class="alert alert-warning py-2 mb-3 small">
        <i class="fas fa-exclamation-triangle me-2"></i>
        Der Registrierungs-/Reset-Link für diesen Nutzer ist abgelaufen.
        Bitte senden Sie einen neuen Link.
    </div>
{/if}

<form on:submit|preventDefault={updateUser}>
    <div class="row mb-2">
        <div class="col">
            <label class="small" for="edit_prename">Vorname</label>
            <input type="text" class="form-control" id="edit_prename" bind:value={prename}>
        </div>
        <div class="col">
            <label class="small" for="edit_name">Nachname</label>
            <input type="text" class="form-control" id="edit_name" bind:value={name}>
        </div>
    </div>

    <div class="mb-3">
        <label class="small" for="edit_mail">E-Mail Adresse</label>
        <input type="email" class="form-control" id="edit_mail" bind:value={mail}>
    </div>

    {#if errorMsg}
        <div class="alert alert-danger p-2 small">{errorMsg}</div>
    {/if}
    {#if successMsg}
        <div class="alert alert-success p-2 small"><i class="fas fa-check"></i> {successMsg}</div>
    {/if}

    <div class="d-flex justify-content-between align-items-center mt-4 border-top pt-3">
        <button type="button" class="btn btn-outline-danger btn-sm" on:click={deleteUser}>
            <i class="fas fa-trash"></i> Löschen
        </button>

        <div>
            <button type="button"
                    class="btn btn-sm me-1 {linkExpired ? 'btn-warning text-dark' : 'btn-outline-secondary'}"
                    on:click={resendLink}
                    title="Sendet einen neuen Registrierungs- oder Reset-Link">
                <i class="fas fa-paper-plane"></i> {linkExpired ? 'Neuen Link senden' : 'Link senden / PW Reset'}
            </button>

            <button type="submit" class="btn btn-primary btn-sm btn-maleck">
                <i class="fas fa-save"></i> Speichern
            </button>
        </div>
    </div>
</form>

<style>
    .btn-maleck {
        background: #2f3e51;
        border-color: #2f3e51;
    }
</style>
